import defaultProfileAvatar from "../assets/images/default_profile_avatar.svg";

export const DEFAULT_PROFILE_AVATAR = defaultProfileAvatar;

export const normalizeAvatarSrc = (src) => {
  if (src == null) return undefined;
  const value = typeof src === "string" ? src.trim() : src;
  return value ? value : undefined;
};

export default DEFAULT_PROFILE_AVATAR;
